import type { IOptimizationConfig, RangeWithStepOrNumber } from "types";

const CHECKBOX_FIELD_MAP: Record<string, keyof IOptimizationConfig> = {
  ignore_ti: "ignoreTi",
  ignore_rei: "ignoreRei",
  distanceBetweenPoles: "shouldOptimizeDistanceBetweenPoles",
  heightOfTheLightPoint: "shouldOptimizeHeightOfTheLightPoint",
  overhang: "shouldOptimizeOverhang",
  tiltOfTheLuminaire: "shouldOptimizeTiltOfTheLuminaire",
};

const RANGE_FIELDS = ["distanceBetweenPoles", "heightOfTheLightPoint", "overhang", "tiltOfTheLuminaire"] as const;
type RangeField = (typeof RANGE_FIELDS)[number];

export function applyCheckboxField(config: IOptimizationConfig, name: string, data: boolean): IOptimizationConfig | null {
  const field = CHECKBOX_FIELD_MAP[name];
  if (!field) return null;
  return { ...config, [field]: data };
}

export function applyRangeField(config: IOptimizationConfig, name: string, data: RangeWithStepOrNumber): IOptimizationConfig | null {
  if (!(RANGE_FIELDS as readonly string[]).includes(name)) return null;
  const field = name as RangeField;
  const current = config[field] as { value: number; rangeValue: { min: number; max: number; step: number } };
  const updatedField = typeof data === "number" ? { ...current, value: data } : data;
  return { ...config, [field]: updatedField };
}
